module.exports = __webpack_public_path__ + "img/cecile_avatar.f8bed491.jpg";